module.exports = __webpack_public_path__ + "img/organization.73982d53.svg";